module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 11
// module chunks = 0 1